import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse } from '../types';

const USER_ADMIN_TAG_URL = '/v2/user-admin-tags';

class UserAdminTagService {
  static getByFilter(params: string, config?: AxiosRequestConfig): Promise<PagedResponse<unknown>> {
    return axios.get(`${USER_ADMIN_TAG_URL}${params}`, config);
  }

  static create(data: Record<string, unknown>, config?: AxiosRequestConfig): Promise<DataResponse<unknown>> {
    return axios.post(`${USER_ADMIN_TAG_URL}`, data, config);
  }

  static delete(id: number, config?: AxiosRequestConfig): Promise<unknown> {
    return axios.delete(`${USER_ADMIN_TAG_URL}/${id}`, config);
  }
}

export { UserAdminTagService };
